import React, { FC, ReactNode } from 'react'

export const TuvSeal: FC<ReactNode> = () => {
  return (
    <img
      src={
        'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/ac8f66c25b44e56caabe52a61fc89661_tuv-sigel-immoscout-2023.svg'
      }
      alt={''}
    />
  )
}
